module.exports = __webpack_public_path__ + "static/img/function3.b8e65e6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/function3.gif
// module id = pvuB
// module chunks = 0